import React from 'react'

export function MetricCard({ label, value, subtitle, delta }) {
  const isPositiveDelta = delta !== null && delta !== undefined && delta > 0
  const isNegativeDelta = delta !== null && delta !== undefined && delta < 0

  return (
    <div style={styles.card}>
      <div style={styles.label}>{label}</div>
      <div style={styles.value}>{value ?? '—'}</div>
      {subtitle && <div style={styles.subtitle}>{subtitle}</div>}
      {delta !== null && delta !== undefined && (
        <div style={{
          ...styles.delta,
          color: isPositiveDelta ? '#2d6a4f' : isNegativeDelta ? '#842029' : 'var(--text-secondary)',
        }}>
          {isPositiveDelta ? '+' : ''}{delta}
        </div>
      )}
    </div>
  )
}

const styles = {
  card: {
    background: '#f6f5f3',
    borderRadius: 'var(--radius)',
    padding: '16px 20px',
  },
  label: {
    fontSize: 12,
    color: 'var(--text-secondary)',
    marginBottom: 6,
  },
  value: {
    fontSize: 22,
    fontWeight: 500,
    color: 'var(--text-primary)',
    lineHeight: 1.2,
  },
  subtitle: {
    fontSize: 11,
    color: 'var(--text-secondary)',
    marginTop: 4,
  },
  delta: {
    fontSize: 11,
    marginTop: 3,
  },
}
